import React from 'react';
import { Card } from './ui';
import { Star, XCircle } from 'lucide-react';
export function Testimonials() {
  return <section className="py-10 bg-slate-900/50 border-y border-slate-800" data-id="element-39">
      <div className="max-w-6xl mx-auto px-4" data-id="element-40">
        <div className="flex flex-wrap justify-center gap-6 md:gap-14 text-center mt-[22px] mb-[22px]" data-id="element-41">
          <div data-id="element-42">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-43">+1.200</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-44">
              familias confían
            </p>
          </div>
          <div data-id="element-45">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-46">6</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-47">
              Tomos listos
            </p>
          </div>
          <div data-id="element-48">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-49">5</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-50">
              Bonos incluidos
            </p>
          </div>
          <div data-id="element-51">
            <p className="text-3xl font-bold text-white mb-1 flex items-center justify-center gap-1" data-id="element-52">
              4.9/5 <Star className="w-6 h-6 fill-amber-400 text-amber-400" data-id="element-53" />
            </p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-54">
              calificación
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-55">
          <Card className="bg-slate-900" data-id="element-56">
            <div className="flex gap-1 mb-4" data-id="element-57">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-58" />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-59">
              "En pocos días dejó atrás los accidentes de pis. Tener el paso a
              paso nos devolvió la calma en casa."
            </p>
            <div className="flex items-center gap-3" data-id="element-60">
              <div className="w-10 h-10 rounded-full bg-brand-900 flex items-center justify-center text-brand-400 font-bold" data-id="element-61">
                MG
              </div>
              <div data-id="element-62">
                <p className="font-bold text-white" data-id="element-63">Mariana G.</p>
                <p className="text-xs text-slate-500" data-id="element-64">Córdoba</p>
              </div>
            </div>
          </Card>

          <Card className="bg-slate-900" data-id="element-65">
            <div className="flex gap-1 mb-4" data-id="element-66">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-67" />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-68">
              "Por fin entendimos cómo frenar el mordisqueo destructivo sin
              retos eternos. Su comportamiento cambió muchísimo."
            </p>
            <div className="flex items-center gap-3" data-id="element-69">
              <div className="w-10 h-10 rounded-full bg-emerald-900 flex items-center justify-center text-emerald-400 font-bold" data-id="element-70">
                LP
              </div>
              <div data-id="element-71">
                <p className="font-bold text-white" data-id="element-72">Laura P.</p>
                <p className="text-xs text-slate-500" data-id="element-73">Rosario</p>
              </div>
            </div>
          </Card>

          <Card className="bg-slate-900" data-id="element-74">
            <div className="flex gap-1 mb-4" data-id="element-75">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-76" />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-77">
              "Ahora duerme tranquilo y todos descansamos mejor. Tener una
              rutina clara hizo a nuestra familia mucho más feliz."
            </p>
            <div className="flex items-center gap-3" data-id="element-78">
              <div className="w-10 h-10 rounded-full bg-blue-900 flex items-center justify-center text-blue-400 font-bold" data-id="element-79">
                RM
              </div>
              <div data-id="element-80">
                <p className="font-bold text-white" data-id="element-81">Roberto M.</p>
                <p className="text-xs text-slate-500" data-id="element-82">Buenos Aires</p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}
export function Problem() {
  return <section className="py-12 px-4" data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <h2 className="text-2xl md:text-4xl font-bold text-center text-white mb-5" data-id="element-85">
          ¿Cuántos días más vas a sentirte así?
        </h2>

        <p className="text-slate-300 text-center text-[16px] mt-[11px] mb-[11px]" data-id="element-86">
          Querés darle a tu cachorro un buen comienzo. Querés educarlo con amor.
          Pero nadie te dijo que las primeras semanas podían sentirse como un
          caos: pis por toda la casa, mordidas, noches sin dormir y la duda de
          si lo estás haciendo bien.
        </p>

        <p className="text-lg font-bold text-center text-brand-400 mb-6" data-id="element-87">
          No es falta de amor. Es falta de una guía clara.
        </p>

        <Card className="bg-slate-900/80 border-red-900/30 mb-6" data-id="element-88">
          <ul className="space-y-3" data-id="element-89">
            {['Limpiás accidentes de pis una y otra vez sin saber cómo prevenirlos', 'Muerde muebles, manos y objetos porque todavía no conoce los límites', 'Las noches se hacen largas y nadie logra descansar bien', 'Probás consejos distintos y cada persona te dice algo diferente', 'Querés que se porte mejor, pero no sabés qué entrenar primero', 'La familia se frustra cuando convivir debería ser una alegría'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-90">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-91" />
                <span className="text-slate-300 text-lg" data-id="element-92">{item}</span>
              </li>)}
          </ul>
        </Card>

        <h3 className="text-2xl md:text-3xl font-bold text-center text-white" data-id="element-93">
          ¿Y si esta fuera la última semana de caos?
        </h3>
      </div>
    </section>;
}